import React, { Component } from "react";
import { connect } from "react-redux";
import Snackbar from "material-ui/Snackbar";
import * as uiActions from "../store/ui/uiActions";
import * as uiSelectors from "../store/ui/uiSelectors";

class Toast extends Component {
  _onClose = () => {
    this.props.clear();
  };

  render() {
    const { message } = this.props;
    return (
      <Snackbar
        open={!!message}
        message={message || ""}
        autoHideDuration={4000}
        onRequestClose={this._onClose}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    message: uiSelectors.getToastMessage(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    clear: () => dispatch(uiActions.showToastMessage(null))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Toast);



// WEBPACK FOOTER //
// ./src/components/Toast.js